import axios from 'axios'
export default async contractId => {
    try {
        //
        const route = process.env.VUE_APP_API_ROUTE.concat(
            `/hr_contract/${contractId}/activate`
        )
        const response = await axios.post(route)
        //
        return response.data
    } catch (error) {
        //
        return error.response.data
    }
}
